<script lang="ts">
  import { onMount } from "svelte";
  import { request } from './httphelper';
  export let error = null;

  let currentGroup = -1;
  let groups : Groups[] = [];

  let matches : MatchedNames[] = [];

  $: getMatches(currentGroup);

  onMount(async () => {
    getGroups();

  });


  async function  getGroups() {
    const response = await request<Groups[]>(new Request(`/groups.php`));
    if (!response.ok || response.apiResponseStatus != 0 || !response.parsedBody) {
      error = 'Fehler beim Abrufen der Gruppen ' + response.apiResponseStatus;
      return ;
    }
    else {
      groups = response.parsedBody;
      currentGroup = (groups.length > 0) ? 0 : -1;
    }
  }

  async function  getMatches(groupIndex : number) {
    if (groupIndex < 0 || groupIndex >= groups.length) return ;
    const response = await request<MatchedName[]>(new Request(`/matches.php?groupid=${groups[groupIndex].id}`));
    if (!response.ok || response.apiResponseStatus != 0 || !response.parsedBody) {
      error = 'Fehler beim Abrufen der Treffer ' + response.apiResponseStatus;
      return ;
    }
    else {
      matches = response.parsedBody.sort( (lhs : MatchedName, rhs : MatchedName) => {
        if (lhs.name > rhs.name) return 1;
        if (lhs.name < rhs.name) return -1;
        return 0;
      }
      );
    }
  }

  interface Groups {
    id : number,
    name : string
  }

  interface MatchedName {
    name : string,
    rating : number,
    groups_ratings : { username : string, rating : number}[]
  }
</script>

{#if groups.length <= 0}
No groups
{/if}
{#if !error && groups.length > 0}
<div style="margin-top: 5px;margin-bottom: 5px;">Welche Gruppe willst du checken?<br>
  <select bind:value={currentGroup}>
    {#each groups as group, index}
    <option value={index}>{group.name}</option>
    {/each}
  </select>
</div>
<div>
  Treffer: {matches.length}
</div>
{#each matches as currentName}
<div class="name">
  <h4>{currentName.name}</h4>
  <div class="flexcontainer">
    <div>Meine Bewertung: {currentName.rating == 6 ? 'akzeptiert' : currentName.rating + ' von 5' } </div>
    {#each currentName.groups_ratings as partnerrating }
      <div>{partnerrating.username}s Bewertung: {partnerrating.rating == 6 ? 'akzeptiert' : partnerrating.rating + ' von 5' }</div>
    {/each}
  </div>
</div>
{/each}
{/if}

<style>
  h4 {
    margin: 2px;
  }
  .name {
    border: 1px solid black;
    margin-bottom: 5px;
    padding: 2px;
  }
  .flexcontainer {
    display: flex;
    flex-wrap: wrap;
  }
  .flexcontainer div {
    margin: 5px 5px 5px 0;
  }
</style>